// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1esbT","footer":"styles_footer__3m855"};